// extracted by mini-css-extract-plugin
export var configurationSection = "_tk-0";